import IncDonutChart from 'components/charts/inc-donut-chart/inc-donut-chart.component';
import { useSearchQueryContext } from 'components/search/search.hooks';
import { useTranslation } from 'react-i18next';

const BrandOrders = () => {
  const { t } = useTranslation();
  const {
    data,
    queryState: { isFetching },
  } = useSearchQueryContext('brandOrders');

  return (
    <IncDonutChart
      data={data?.data}
      title={t('page.loyaltyPerformanceReport.loyaltyAccountOrders.title')}
      data-testid="BrandOrders.IncDonutChart"
      PieChartProps={{
        loading: isFetching,
        sx: {
          maxHeight: 450,
        },
      }}
    />
  );
};

export default BrandOrders;
